"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactTextField = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var Autocomplete_1 = __importDefault(require("@material-ui/lab/Autocomplete"));
var styles_1 = __importDefault(require("./styles"));
var hooks_1 = require("../../hooks");
var TextField_1 = require("../../atoms/TextField");
exports.ContactTextField = react_1.default.memo(function (_a) {
    var label = _a.label, onChange = _a.onChange, _b = _a.limitTags, limitTags = _b === void 0 ? 5 : _b, setSearchCriteria = _a.setSearchCriteria, _c = _a.options, options = _c === void 0 ? [] : _c, fetchingOptions = _a.fetchingOptions, value = _a.value, _d = _a.isEmail, isEmail = _d === void 0 ? false : _d, _e = _a.multiple, multiple = _e === void 0 ? true : _e, autocompleteProps = _a.autocompleteProps, rest = __rest(_a, ["label", "onChange", "limitTags", "setSearchCriteria", "options", "fetchingOptions", "value", "isEmail", "multiple", "autocompleteProps"]);
    var styles = (0, styles_1.default)();
    var _f = react_1.default.useState(false), open = _f[0], setOpen = _f[1];
    var debounce = (0, hooks_1.useDebounce)(setSearchCriteria).debounce;
    var isObject = (0, react_1.useCallback)(function (object) { return typeof object === 'object'; }, []);
    var _g = react_1.default.useState(value), currentValue = _g[0], setCurrentValue = _g[1];
    var handlerChange = (0, react_1.useCallback)(function (event, values, details) {
        if (details === 'select-option')
            setOpen(false);
        onChange(isEmail
            ? values.map(function (val) { return (isObject(val) ? val.email : val); })
            : values);
        setCurrentValue(isEmail
            ? values.map(function (val) { return (isObject(val) ? val.email : val); })
            : values);
        setSearchCriteria('This string should not be empty');
    }, [isEmail, isObject, onChange, setSearchCriteria]);
    /**
     * Modifies key TAB behavior to be same as key ENTER
     * @param event KeyboardEvent
     * @returns void
     */
    var handleKeyDown = (0, react_1.useCallback)(function (event) {
        var inputValue = event.target.value;
        if (!inputValue)
            return;
        switch (event.key) {
            case 'Tab': {
                event.preventDefault();
                event.stopPropagation();
                if (inputValue.length) {
                    // refresh UI chips of values
                    setCurrentValue(__spreadArray(__spreadArray([], currentValue, true), [inputValue], false));
                    // Send the value to the General form
                    handlerChange(event, __spreadArray(__spreadArray([], currentValue, true), [inputValue], false), event.key);
                }
                break;
            }
            default:
        }
    }, [currentValue, handlerChange]);
    var handleUsernameBlur = (0, react_1.useCallback)(function (e) {
        var newInput = e.target.value;
        e.preventDefault();
        e.stopPropagation();
        if (newInput) {
            setCurrentValue(__spreadArray(__spreadArray([], currentValue, true), [newInput], false));
            handlerChange(e, __spreadArray(__spreadArray([], currentValue, true), [newInput], false));
        }
    }, [currentValue, handlerChange]);
    return ((0, jsx_runtime_1.jsx)(Autocomplete_1.default, __assign({ onKeyDown: handleKeyDown, open: open, onInputChange: function (_, innerValue, details) {
            if (details === 'reset') {
                setOpen(false);
            }
            else if (innerValue.length === 0) {
                if (open)
                    setOpen(false);
            }
            else if (!open)
                setOpen(true);
        }, onChange: handlerChange, onBlur: handleUsernameBlur, multiple: multiple, freeSolo: isEmail, loading: fetchingOptions, loadingText: "Searching", noOptionsText: "No Matches Found", value: currentValue, options: options, limitTags: limitTags, fullWidth: true, classes: { root: styles.autocomplete } }, autocompleteProps, { renderTags: function (val, getTagProps) {
            return val.map(function (option, index) { return ((0, jsx_runtime_1.jsx)(core_1.Chip, __assign({ id: "option-".concat(index + 1), variant: "outlined", classes: { root: styles.chips }, label: typeof option === 'object' ? option.email : option, deleteIcon: (0, jsx_runtime_1.jsx)(icons_1.ClearRounded, { "data-testid": "delete-chip-icon", color: "inherit", height: "12", width: "12" }) }, getTagProps({ index: index })), "option-".concat(index + 1))); });
        }, renderOption: function (option) {
            return isObject(option) ? "".concat(option.name, " | ").concat(option.email) : option;
        }, getOptionLabel: function (option) { return (isObject(option) ? "".concat(option.name) : option); }, filterSelectedOptions: true, getOptionSelected: function (option, val) {
            if (isObject(option)) {
                return isObject(val) ? option.email === val.email : option.email === val;
            }
            return option === val;
        }, renderInput: function (params) {
            var newParams = __assign(__assign(__assign({}, params), rest), { inputProps: __assign(__assign({}, params.inputProps), { id: rest.id, name: rest.name }) });
            return ((0, jsx_runtime_1.jsx)(TextField_1.TextField, __assign({}, newParams, { placeholder: "Type to search", onChange: function (e) {
                    debounce(e.target.value);
                }, label: label })));
        } })));
});
